import { render } from "./RiFreeUse.vue?vue&type=template&id=2beefbbe"
import script from "./RiFreeUse.vue?vue&type=script&lang=js"
export * from "./RiFreeUse.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiFreeUse.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2beefbbe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2beefbbe', __exports__)) {
    api.reload('2beefbbe', __exports__)
  }
  
  module.hot.accept("./RiFreeUse.vue?vue&type=template&id=2beefbbe", () => {
    api.rerender('2beefbbe', render)
  })

}


export default __exports__